// ── Decimal precision ─────────────────────────────────────────────────────────
// Number of decimal places used for all billing monetary display and calculations.
// Must match BILLING_DECIMAL_PLACES in soracom-backend and soracom-worker.
export const BILLING_DECIMAL_PLACES = 5;
export const BILLING_DECIMAL_FACTOR = Math.pow(10, BILLING_DECIMAL_PLACES);

/** Round a number to BILLING_DECIMAL_PLACES decimal places */
export const roundBilling = (n) =>
  Math.round(n * BILLING_DECIMAL_FACTOR) / BILLING_DECIMAL_FACTOR;

/** Format a billing monetary value as a fixed-decimal string */
export const formatBillingAmount = (n) =>
  (n ?? 0).toFixed(BILLING_DECIMAL_PLACES);
